'use client';

import { cn } from "@/lib/utils";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

type NoteFeature = {
  url: string;
  caption: string;
  description?: string;
  imageStyle: Record<string, string>;
};

type NoteFeaturesProps = {
  features?: NoteFeature[];
  autoplayInterval?: number;
}

const defaultFeatures = [{
  "url": "/images/new-section-05-1-notes-excerpt.png",
  "caption": "文献随时划线摘录",
  "imageStyle": {
    width: '347px',
    height: '156px',
    top: '147px',
    left: '0'
  }
}, {
  "url": "/images/new-section-05-2-ai-qna-on-the-go.png",
  "caption": "AI 问答随问随记",
  "imageStyle": {
    width: '273px',
    height: '282px',
    top: '0',
    left: '383px'
  }
}, {
  "url": "/images/new-section-05-3-important-icons.png",
  "caption": "重要图表截图记录",
  "imageStyle": {
    width: '273px',
    height: '178px',
    top: '303px',
    left: '357px'
  }
}]
export const NoteFeatures = ({
  features = defaultFeatures,
  autoplayInterval = 3000,
}: NoteFeaturesProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    function startTimer() {
      timerRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
      }, autoplayInterval);
    }

    startTimer();

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [features.length, autoplayInterval]);

  const handleFeatureClick = (index: number) => {
    setCurrentIndex(index);
    if (timerRef.current) {
      clearInterval(timerRef.current);
      startTimer();
    }
  };

  const startTimer = () => {
    timerRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
    }, autoplayInterval);
  };

  return (
    <div className="h-full w-full flex items-center justify-between overflow-hidden py-10">
      <div className="w-fit">
        <h2 className="text-[40px] leading-[52px] font-semibold">
          3大笔记功能， <br />
          打造极致笔记体验。
        </h2>
        <div
          className="flex flex-col transition-all duration-300 mt-10"
        >
          {
            features.map((feature, index) => (
              <div
                key={index}
                data-feature-index={index}
                className={cn(
                  "flex items-center space-x-2 text-sm leading-[38px] text-muted-foreground",
                  currentIndex === index && "font-bold"
                )}
                onClick={() => {
                  handleFeatureClick(index);
                }}
              >
                <div className="group inline-block">
                  <div
                    className={cn(
                      "box-content w-[6px] h-[6px] border-[6px] rounded-full group-hover:border-muted group-hover:scale-125 transition ease-in-out duration-200",
                      currentIndex === index ? "border-muted-foreground/10" : "border-transparent",
                    )}
                  >
                    <span className="box-content relative -top-[3px] -left-[3px] block w-0 h-0 border-[6px] border-muted-foreground rounded-full scale-50 transition ease-in-out duration-200" />
                  </div>
                </div>
                <span className="cursor-pointer">{feature.caption}</span>
              </div>
            ))
          }
        </div>
      </div>
      <div className="w-[680px] h-[500px] relative flex">
        <div className="absolute left-[160px] top-[73px] w-[423px] h-[339px] rounded-[29px] opacity-50 backdrop-blur-md bg-background/45" />
        {
          features.map((feature, index) => (
            <Image
              key={index}
              priority
              width={parseInt(feature.imageStyle.width)}
              height={parseInt(feature.imageStyle.height)}
              src={feature.url}
              alt={feature.caption}
              draggable="false"
              onClick={() => {
                handleFeatureClick(index);
              }}
              className={cn(
                "absolute rounded-[16px] transition-all duration-30 cursor-pointer select-none",
                currentIndex === index && "shadow-[0_9px_28px_rgba(78,89,105,0.1)] -translate-y-1",
              )}
              style={feature.imageStyle}
            />
          ))
        }
      </div>
    </div>
  );
};